import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
import { useGetOffsetValue } from "@/app/helpers/StickyOffset";

interface PagerItem {
  label: number,
  current: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ListPager',
  props: {
    currentPage: null,
    totalPages: null,
    maxItems: { default: 3 }
  },
  emits: ["update:currentPage"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:currentPage', id: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { currentPage: Number, totalPages: Number, maxItems: Number };





const items = computed((): PagerItem[] => {
  const items: PagerItem[] = []
  for (let i = pageFirst.value; i <= pageLast.value; i+= 1) {
    const item: PagerItem = {
      label: i,
      current: (i === pageCurrent.value)
    }
    items.push(item)
  }
  return items
})

const pagerEl = ref(null)

const pageCurrent: Number = ref(props.currentPage)

const pageFirst = computed((): Number => {
  if (pageCurrent.value === 1) return 1
  if (pageCurrent.value === props.totalPages) return (Math.max(props.totalPages - props.maxItems + 1, 1))
  return (pageCurrent.value - 1)
})

const pageLast = computed((): Number => {
  return Math.min(pageFirst.value + props.maxItems - 1, props.totalPages)
})

const goToPage = (page: Number): void => {
  if (page > 0 && page <= props.totalPages) {
    pageCurrent.value = (page !== props.currentPage) ? page : pageCurrent.value
    scrollUp()
    emit('update:currentPage', pageCurrent.value)
  }
}

const goToPrevPage = (): void => {
  if (pageCurrent.value > 1) {
    goToPage(pageCurrent.value - 1)
  }
}

const goToFirstPage = (): void => {
  goToPage(1)
}

const goToNextPage = (): void => {
  goToPage(pageCurrent.value + 1)
}

const goToLastPage = (): void => {
  goToPage(props.totalPages)
}

const scrollUp = (): void => {
  if (pagerEl.value instanceof HTMLElement && pagerEl.value.offsetParent instanceof HTMLElement) {
    window.scrollTo(0, useGetOffsetValue(pagerEl.value.offsetParent, 'top') + pagerEl.value.offsetParent.offsetTop)
  }
}

return { __sfc: true,emit, props, items, pagerEl, pageCurrent, pageFirst, pageLast, goToPage, goToPrevPage, goToFirstPage, goToNextPage, goToLastPage, scrollUp }
}

})